import { defineStore } from "pinia";

interface Bike {
  id: number | null;
  serialNumber: string | null;
  danfe: string | null;
}

interface User {
  id: string | null;
  name: string | null;
  email: string | null;
  phone: string | null;
  cpf: string | null;
  type: string | null;
}

interface Address {
  postalCode: string | null;
  street: string | null;
  number: string | null;
  complement: string | null;
  neighborhood: string | null;
  city: string | null;
  state: string | null;
}

interface Files {
  selfie: File | null;
  photo: File | null;
  video: File | null;
}

interface FormState {
  hasBike: boolean;
  bike: Bike;
  planIds: number[];
  user: User;
  address: Address;
  files: Files;
  insuranceCode: string | null;
  tag: string | null;
  bikeSku: string | null;
  needsBike: boolean | null;
  fromBikeshop: boolean;
}

export const useFormStore = defineStore("form", {
  state: (): FormState => ({
    hasBike: false,
    bike: {
      id: null,
      serialNumber: null,
      danfe: null,
    },
    planIds: [],
    user: {
      id: null,
      name: null,
      email: null,
      phone: null,
      cpf: null,
      type: null,
    },
    address: {
      postalCode: null,
      street: null,
      number: null,
      complement: null,
      neighborhood: null,
      city: null,
      state: null,
    },
    files: {
      selfie: null,
      photo: null,
      video: null,
    },
    insuranceCode: null,
    tag: null,
    bikeSku: null,
    needsBike: null,
    fromBikeshop: false,
  }),
  actions: {
    reset() {
      (this.needsBike = null),
        (this.bike = {
          id: null,
          serialNumber: null,
          danfe: null,
        });
      this.planIds = [];
      this.user = {
        id: null,
        name: null,
        email: null,
        phone: null,
        cpf: null,
        type: null,
      };
      this.address = {
        postalCode: null,
        street: null,
        number: null,
        complement: null,
        neighborhood: null,
        city: null,
        state: null,
      };
      this.files = {
        selfie: null,
        photo: null,
        video: null,
      };
    },
  },
  persist: {
    storage: sessionStorage,
  },
});

export type UseFormStore = ReturnType<typeof useFormStore>;
